import queryString from 'query-string'

const options = { arrayFormat: 'comma', sort: false } as const

type ParsedQuery = Record<string, string | string[]>

export enum LayoutQueryParam {
  Default = 'default',
  Basic = 'basic',
  Iframe = 'iframe',
}

export type LayoutQueryParamType = `${LayoutQueryParam}`

export function parse(query: string | URL) {
  query = typeof query === 'string' ? query : query.search
  return queryString.parse(query, options) as ParsedQuery
}

/**
 * Encodes a query object into a query string.
 *
 * @param query A query object where values are strings or arrays of strings.
 * @returns The encoded query string.
 *
 * This function is a wrapper around `query-string.stringify` that handles
 * nested objects under the key `fields` in a special way. It will flatten
 * those objects into a series of query string parameters with the syntax
 * `fields[key]=value`.
 */
export function stringify(query: Parameters<typeof queryString.stringify>[0]) {
  if (query.fields && typeof query.fields === 'object') {
    query = Object.entries(query.fields).reduce(
      (acc, [key, value]) => {
        acc[`fields[${key}]`] = decodeURI(String(value as string[]))
        return acc
      },
      { ...query },
    )

    delete query.fields
  }

  return queryString.stringify(query, options)
}
